<script setup>
import BreezeButton from '@/Components/Button.vue';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import { Head, Link, useForm } from '@inertiajs/vue3';
import {onMounted, ref} from "vue";

const form = useForm({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    terms: false,
	jwt: ''
});



const submit = () => {
    form.post(route('register'), {
        onFinish: () => form.reset('password', 'password_confirmation'),
    });
};

const loginWithGoogleButton = ref(null)

onMounted(() => {
	const script = document.createElement("script");
	script.src = "https://accounts.google.com/gsi/client";
	script.async = true;
	document.head.appendChild(script);
	// Load the Google Identity Services script

	script.onload = () => {
		window.google.accounts.id.initialize({
			client_id: "147162821536-t5fih176q0otrm1f9c34lknut5mnf6hq.apps.googleusercontent.com",
			callback: handleCredentialResponse
		})

		window.google.accounts.id.renderButton(
			loginWithGoogleButton.value,
			{ theme: "outline", size: "large", width: '400', text: 'signup_with' }
		)

		// window.google.accounts.id.prompt() // this is "one tap" login in the top right corner
	}
});

function handleCredentialResponse(response) {
	form.jwt = response.credential;
	form.post('login', {
		onFinish: () => {
			console.log("created based on google login");
		},
	});
}


</script>

<template>
    <BreezeGuestLayout>
        <Head title="Register" />

        <BreezeValidationErrors class="mb-4" />

		<div ref="loginWithGoogleButton" class="pt-2"></div>

		<div class="flex items-center mt-4">
			<hr class="flex-1 my-5">
			<span class="mx-4 text-sm">Or complete the form</span>
			<hr class="flex-1 my-5">
		</div>


        <form @submit.prevent="submit">
            <div>
                <BreezeLabel for="name" value="Name" />
                <BreezeInput id="name" type="text" class="mt-1 block w-full" v-model="form.name" required autofocus autocomplete="name" />
            </div>

            <div class="mt-4">
                <BreezeLabel for="email" value="Email" />
                <BreezeInput id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autocomplete="username" />
            </div>

            <div class="mt-4">
                <BreezeLabel for="password" value="Password" />
                <BreezeInput id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="new-password" />
            </div>

            <div class="mt-4">
                <BreezeLabel for="password_confirmation" value="Confirm Password" />
                <BreezeInput id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
            </div>

            <div class="flex items-center justify-end mt-4">
                <Link :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900">
                    Already registered?
                </Link>

                <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    Register
                </BreezeButton>
            </div>
        </form>
    </BreezeGuestLayout>
</template>
